import { LLM_STATUS } from "../types/enums";
import { IMessage } from "../types/interfaces";

/**
 * 將 IMessage 轉換為 chat-widget 需要的格式
 * 提供 llm_status 的 fallback 機制以支援舊資料
 */
export const transformMessageForWidget = (message: IMessage) => {
    return {
        id: message.id,
        body: message.text,
        sender: message.role === "bot" ? "System" : "User",
        timestamp: message.created_at,
        type: "text",
        llm_status: message.llm_status ?? LLM_STATUS.UNKNOWN,
    };
};
